'use client';

import { useCallback } from 'react';

import { useAnalyticsForwarding } from '@/hooks/use-analytics-forwarding';
import { useSafePostHog } from '@/hooks/use-safe-posthog';

interface TrackEventParams {
  event: string;
  properties?: Record<string, unknown>;
}

function flattenProperties(
  properties?: Record<string, unknown>,
): Record<string, unknown> | undefined {
  if (!properties) return properties;

  const flattened: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(properties)) {
    flattened[key] = Array.isArray(value) ? value.join(',') : value;
  }
  return flattened;
}

export function useTrackEvent() {
  const posthog = useSafePostHog();
  const { forwardEvent } = useAnalyticsForwarding();

  const trackEvent = useCallback(
    ({ event, properties }: TrackEventParams) => {
      const normalized = flattenProperties(properties);
      posthog?.capture(event, normalized);
      forwardEvent({ eventName: event, properties: normalized });
    },
    [posthog, forwardEvent],
  );

  return trackEvent;
}
